import { useState } from "react"
import { JobbinInputWhite } from "../../components/jobbinInputWhite"
import { LoadingComponent } from "../../components/loading"
import { JobbinPrimaryButton } from "../../components/primaryButton"
import { useLoading } from "../../context/loading"
import { LoginUser } from "./model"
import { useNavigate } from "react-router-dom"
import { useLoginUser } from "../../hooks/auth-hooks"

export const Login = () => {
    const { loading, setLoading } = useLoading()
    const { loginUser } = useLoginUser()
    const navigate = useNavigate()

    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [error, setError] = useState<string | null>(null)

    const doLogin = async () => {
        setError(null)

        if (!email || !password) {
            setError("Completați toate câmpurile.")
            return
        }

        setLoading(true)

        try {
            const data = await loginUser({ email, password } as LoginUser)
            localStorage.setItem("jwtToken", data.token)
            navigate("/home")
        } catch (e: any) {
            setError(e.message)
        } finally {
            setLoading(false)
        }
    }

    return (
        <div id="login-page" className="bg-figmaLightBg min-h-screen">
            {loading ? <LoadingComponent /> : null}

            <div className="grid min-h-screen grid-cols-1 lg:grid-cols-12">
                <div className="col-span-1 lg:col-span-5 flex items-center justify-center px-4 py-8 sm:px-6 md:px-8">
                    <div className="w-full max-w-md">
                        <img
                            className="mt-2 mb-8 w-[140px] sm:w-[170px]"
                            src="/images/jobbin-logo-with-icon.png"
                            alt="Jobbin"
                        />

                        <div className="text-start">
                            <h3 className="text-figmaBlack text-[28px] sm:text-[32px] font-bold">
                                Logare
                            </h3>
                            <p className="mt-2 text-figmaDarkGray font-bold">
                                Vă rugăm să vă logați
                            </p>
                        </div>

                        {error && (
                            <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg text-sm">
                                {error}
                            </div>
                        )}

                        <div className="mt-6">
                            <JobbinInputWhite
                                type="email"
                                iconStart="mail-icon.svg"
                                label="Adresa email"
                                name="email"
                                placeholder="Introduceti adresa de email"
                                onChange={(e) => setEmail((e.target as HTMLInputElement).value)}
                            />
                        </div>

                        <div className="mt-4">
                            <JobbinInputWhite
                                type="password"
                                iconStart="locket.svg"
                                label="Parola"
                                name="parola"
                                placeholder="Parola dumneavoastră"
                                onChange={(e) => setPassword((e.target as HTMLInputElement).value)}
                            />
                        </div>

                        <div className="mt-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                            <p
                                className="text-figmaBlack font-bold cursor-pointer text-sm sm:text-base"
                                onClick={() => navigate("/signup")}
                            >
                                Înregistrați-vă aici
                            </p>
                            <p
                                className="text-figmaContrast font-bold cursor-pointer text-sm sm:text-base"
                                onClick={() => navigate("/forgot-password")}
                            >
                                V-ați uitat parola?
                            </p>
                        </div>

                        <div className="mt-8">
                            <JobbinPrimaryButton onClickAction={doLogin} text="Logare" />
                        </div>
                    </div>
                </div>

                <div className="hidden lg:flex lg:col-span-7 bg-figmaWhite items-center justify-center p-8">
                    <img
                        className="max-w-full h-auto"
                        src="/images/jobbin-logo-with-icon.png"
                        alt="Jobbin"
                    />
                </div>
            </div>
        </div>
    )
}